<template>
  <v-container  grid-list-xs>    
    <v-row align="center" justify="center" class="mt-3">
      <v-col cols="12" xl="9" lg="9" class="text-justify">

        <v-row align="center" justify="center">
          <v-col cols="12" xl="8" lg="8" class="text-center">
            <h1> <p> Olimpiada Nacional de Química </p></h1>
          </v-col>
        </v-row>

        <h3> <p> Como parte del programa de Olimpiadas Nacionales de la Ciencia, la Academia Mexicana de Ciencias en conjunto con la 
        Facultad de Química de la UNAM y el Comité Estatal sede organizan la Olimpiada Nacional de Química Este concurso se organiza 
        anualmente y participan jóvenes estudiantes de nivel de enseñanza media y consta de tres etapas: concursos estatales, concurso 
        nacional y selección y entrenamiento de las delegaciones que representan a México en las olimpiadas internacionales e iberoamericanas</p></h3>

        <h3><p> Se crea con el objetivo de promover el estudio de las Ciencias Químicas y estimular el desarrollo de jóvenes talentos 
        en esta Ciencia, así como contribuir a la profundización de la amistad entre los estudiantes participantes y crear un marco 
        propicio para fomentar la cooperación, el entendimiento y el intercambio de experiencias. Para finalmente seleccionar a los 
        mejores estudiantes de química de nivel preuniversitario e integrar a las delegaciones que representen a México en olimpiadas internacionales. </p></h3>

        <h3><p>México participó por primera vez en la XXIV Olimpiada Internacional de Química, celebrada en los Estados Unidos de América 
        en julio de 1992, desde entonces a la fecha, los estudiantes mexicanos han obtenido medallas de plata, de bronce y menciones honoríficas.</p></h3>

        <h3><p> México ha participado desde la primera Olimpiada Iberoamericana celebrada en Mendoza, Argentina, en 1995. Los estudiantes mexicanos 
        que han representado al país en estos concursos han obtenido medallas de oro, de plata, de bronce y menciones honoríficas.</p></h3>

        <!-- <h3><a href="https://www.amc.edu.mx/amc/index.php?option=com_content&view=article&id=84&Itemid=80" target="_blank"> Saber más</a></h3> -->

      </v-col>
    </v-row>
  </v-container>  
</template>

<script>
export default {
  metaInfo: {
    title: 'Olimpiada Nacional de Quimica',
    htmlAttrs: {
      lang: 'es',
      amp: true
    }
  },

}
</script>

<style>

</style>